import './styles.scss'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'

import ProcessItem from './ProcessItem'
import { DotsOptionsSelector } from 'components/common'
import { Button } from 'components/Form'
import { getStaticImage } from 'utils/statics'
import { getHexLuminance } from 'utils'

const CategoryCard = ({ category, processType, processes, toggleCategoryModal, toggleDeleteCategoryModal, toggleProcessCalledFromModal, toggleProcessModal, toggleDeleteProcessModal, toggleProcessNotificationModal }) => {
  const [isOpenOptionsSelector, setIsOpenOptionsSelector] = useState(false)

  const toggleOptionsSelector = () => setIsOpenOptionsSelector(!isOpenOptionsSelector)

  return (
    <div
      className='process-list__categories'
      style={{ backgroundColor: category?.color ? category?.color : null }}
    >
      <div className='process-list__categories-header'>
        <strong
          className='process-list__categories-title text-ellipsis'
          style={{ color: (!category?.color || getHexLuminance(category?.color) > 0.4) ? '#E87721' : null }}
        >
          {category ? category.name : 'General'}
        </strong>
        {category && (
          <DotsOptionsSelector
            isOpen={isOpenOptionsSelector}
            toggle={toggleOptionsSelector}
            dotsColor={(!category?.color || getHexLuminance(category?.color) > 0.4) ? '#E87721' : '#ffffff'}
            options={[
              {
                name: I18n.t('dashboard_editCategory'),
                onClick: () => {
                  toggleOptionsSelector()
                  toggleCategoryModal({ mode: 'update', categoryId: category._id })
                }
              },
              {
                name: I18n.t('dashboard_deleteCategory'),
                fontColor: 'red',
                onClick: () => {
                  toggleOptionsSelector()
                  toggleDeleteCategoryModal({ categoryId: category._id })
                }
              }
            ]}
          />
        )}
      </div>
      <div className='process-list__categories-body'>
        {processes.length ? (
          processes.map(process => (
            <ProcessItem
              key={process._id}
              process={process}
              categoryColor={category?.color}
              toggleProcessCalledFromModal={toggleProcessCalledFromModal}
              toggleProcessModal={toggleProcessModal}
              toggleDeleteProcessModal={toggleDeleteProcessModal}
              toggleProcessNotificationModal={toggleProcessNotificationModal}
            />
          ))
        ) : (
          <p
            className='not-found-text not-found-text--processes'
            style={{ color: (!category?.color || getHexLuminance(category?.color) > 0.4) ? '#E87721' : '#ffffff' }}
          >
            {I18n.t('chatbot_processes_notProcess')}
          </p>
        )}
      </div>
      {processType !== 'conversational' && (
        <Button
          clearPrimary
          icon={
            <figure className='process-list__categories-btn-icon'>
              <img
                src={(!category?.color || getHexLuminance(category?.color) > 0.4)
                  ? getStaticImage('/icons/orange-brand/add-circle-icon-primary.svg')
                  : getStaticImage('/icons/orange-brand/add-circle-icon-light.svg')
                }
                alt='Add process'
              />
            </figure>
          }
          className={`
            process-list__categories-btn
            ${category?.color && getHexLuminance(category?.color) < 0.4 ? 'process-list__categories-btn--light' : ''}
          `}
          value={I18n.t('dashboard_addProcess')}
          onClick={() => toggleProcessModal({ mode: 'add', processType, categoryId: category?._id || 'none' })}
        />
      )}
    </div>
  )
}

export default CategoryCard
